import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Arreglo de objetos para pasar los datos a App y el componente Tarea
const DATA = [
  // { id: "todo-0", nombre: "Comer", completado: true },
  // { id: "todo-1", nombre: "Dormir", completado: false },
  // { id: "todo-2", nombre: "Pistear", completado: false },
];

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* Se pasa a App para que allá se lea como props */}
    <App tareas = {DATA} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();